import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../../Layouts/Spinner";
import { onboardingDetailsAdd } from "../../../../redux/zatca/action";
import { useNavigate } from "react-router-dom";
import { ZatcaSubmitvalidation } from "../../../Constant/constant";
import { getUserById } from "../../../../redux/user/action";
import { useParams } from "react-router-dom";

const ZatcaIntegration = ({ activeStep, setActiveStep }) => {
  const selectedUser = useSelector(({ user: { userbyid } }) => userbyid);
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      organization_name: selectedUser?.company_name || "",
      organization_unit_name: "",
      organization_identifier: selectedUser?.company_vat_number || "",
      street_name: "",
      building_number: "",
      city: "",
      postal_code: "",
      district: "",
      country_name: "SA",
      industry_business_category: "",
      user_id: selectedUser?.user_id,
      organization_mail: selectedUser?.email_id,
      mobile_number:
        selectedUser?.country_code + " " + selectedUser?.mobile_number,
    },
    validationSchema: ZatcaSubmitvalidation,
    enableReinitialize: true,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const location_address = [
      values.street_name,
      values.building_number,
      values.city,
      values.postal_code,
      values.district,
    ]
      .filter(Boolean)
      .join(", ");

    const data = {
      ...values,
      location_address,
      currency: "SAR",
      invoice_type: "1100",
      building_number: String(values.building_number),
    };

    dispatch(
      onboardingDetailsAdd(
        data,
        setLoading,
        navigate,
        setActiveStep,
        activeStep
      )
    );
  };

  useEffect(() => {
    if (id) {
      dispatch(getUserById(id));
    }
  }, [id,dispatch]);

  return (
    <div>
      <div className="category-wrapper ">
        <form onSubmit={formik.handleSubmit}>
          <div className="details-wrapper m-0 row business-h1">
            <div className="col-md-12 form-group">
              <label>Company name (Organization name)</label>
              <input
                type="text"
                className="form-control"
                placeholder="Organization name"
                name="organization_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.organization_name}
              />
              {formik.touched.organization_name &&
              formik.errors.organization_name ? (
                <div className="error">{formik.errors.organization_name}</div>
              ) : null}
            </div>
            <div className="col-md-12 form-group">
              <label>Company branch name (Organization unit name)</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter company branch name"
                name="organization_unit_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.organization_unit_name}
              />
              {formik.touched.organization_unit_name &&
              formik.errors.organization_unit_name ? (
                <div className="error">
                  {formik.errors.organization_unit_name}
                </div>
              ) : null}
            </div>
            <div className="col-md-12 form-group">
              <label>Company Vat Number (Organization Identifier)</label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter vat number"
                name="organization_identifier"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.organization_identifier}
              />
              {formik.touched.organization_identifier &&
              formik.errors.organization_identifier ? (
                <div className="error">
                  {formik.errors.organization_identifier}
                </div>
              ) : null}
            </div>
            <div className="col-md-4 form-group">
              <label>Address (As per Wasel Certificate)</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter street name"
                name="street_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.street_name}
              />
              {formik.touched.street_name && formik.errors.street_name ? (
                <div className="error">{formik.errors.street_name}</div>
              ) : null}
            </div>
            <div className="col-md-4 form-group">
              <label></label>
              <br></br>
              <input
                type="number"
                className="form-control"
                placeholder="Enter building number"
                name="building_number"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.building_number}
              />
              {formik.touched.building_number &&
              formik.errors.building_number ? (
                <div className="error">{formik.errors.building_number}</div>
              ) : null}
            </div>
            <div className="col-md-4 form-group">
              <label></label>
              <br></br>
              <input
                type="text"
                className="form-control"
                placeholder="Enter city"
                name="city"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.city}
              />
              {formik.touched.city && formik.errors.city ? (
                <div className="error">{formik.errors.city}</div>
              ) : null}
            </div>
            <div className="col-md-4 form-group">
              <label></label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter postal code"
                name="postal_code"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.postal_code}
              />
              {formik.touched.postal_code && formik.errors.postal_code ? (
                <div className="error">{formik.errors.postal_code}</div>
              ) : null}
            </div>

            <div className="col-md-4 form-group">
              <label></label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter district"
                name="district"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.district}
              />
              {formik.touched.district && formik.errors.district ? (
                <div className="error">{formik.errors.district}</div>
              ) : null}
            </div>
            <div className="col-md-4 form-group">
              <label></label>
              <input
                type="text"
                className="form-control"
                placeholder="enter country name"
                name="country_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={"SA"}
                disabled
              />
              {formik.touched.country_name && formik.errors.country_name ? (
                <div className="error">{formik.errors.country_name}</div>
              ) : null}
            </div>

            <div className="col-md-12 form-group">
              <label>Business Category</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter business category"
                name="industry_business_category"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.industry_business_category}
              />
              {formik.touched.industry_business_category &&
              formik.errors.industry_business_category ? (
                <div className="error">
                  {formik.errors.industry_business_category}
                </div>
              ) : null}
            </div>
          </div>

          <div className="col-md-12">
            <button
              style={{ marginLeft: "10px", color: "white" }}
              className="buttons background-button mx-auto d-block"
              disabled={loading}
              type="submit"
            >
              {!loading ? "Submit" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ZatcaIntegration;
